module.exports = __webpack_public_path__ + "static/media/joker-profile.d99d944a.jpg";